"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALLBACKS = exports.RECOMMENDATIONS_SCRIPT_ID = exports.RECOMMENDATIONS_ID = exports.COMMENT_EMBED_HEIGHT = exports.COMMENT_EMBED_WIDTH = exports.COMMENT_COUNT_SCRIPT_ID = exports.COMMENT_COUNT_CLASS = exports.EMBED_SCRIPT_ID = exports.THREAD_ID = void 0;
var THREAD_ID = 'disqus_thread';
exports.THREAD_ID = THREAD_ID;
var EMBED_SCRIPT_ID = 'dsq-embed-scr';
exports.EMBED_SCRIPT_ID = EMBED_SCRIPT_ID;
var COMMENT_COUNT_CLASS = 'disqus-comment-count';
exports.COMMENT_COUNT_CLASS = COMMENT_COUNT_CLASS;
var COMMENT_COUNT_SCRIPT_ID = 'dsq-count-scr';
exports.COMMENT_COUNT_SCRIPT_ID = COMMENT_COUNT_SCRIPT_ID;
var COMMENT_EMBED_WIDTH = 420;
exports.COMMENT_EMBED_WIDTH = COMMENT_EMBED_WIDTH;
var COMMENT_EMBED_HEIGHT = 320;
exports.COMMENT_EMBED_HEIGHT = COMMENT_EMBED_HEIGHT;
var RECOMMENDATIONS_ID = 'disqus_recommendations';
exports.RECOMMENDATIONS_ID = RECOMMENDATIONS_ID;
var RECOMMENDATIONS_SCRIPT_ID = 'dsq-recs-scr';
exports.RECOMMENDATIONS_SCRIPT_ID = RECOMMENDATIONS_SCRIPT_ID;
var CALLBACKS = ['preData', 'preInit', 'onInit', 'onReady', 'afterRender', 'preReset', 'onIdentify', 'beforeComment', 'onNewComment', 'onPaginate'];
exports.CALLBACKS = CALLBACKS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/disqus-react/lib/constants.js
// module id = 143
// module chunks = 0